import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Copy, ArrowRight, Loader2 } from 'lucide-react';
import { formatDate } from '../../lib/utils';

export function CopyLastWeekDialog({ open, onClose, onCopy, copying, weekDates }) {
  const prevWeekStart = new Date(weekDates[0]);
  prevWeekStart.setDate(prevWeekStart.getDate() - 7);
  const prevWeekEnd = new Date(prevWeekStart);
  prevWeekEnd.setDate(prevWeekEnd.getDate() + 6);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Copy Last Week's Shifts</DialogTitle>
          <DialogDescription>
            All shifts from last week will be copied to this week as drafts.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-2">
          {/* Week range display */}
          <div className="flex items-center gap-3">
            <div className="flex-1 bg-slate-50 border border-slate-200 rounded-lg p-3 text-center">
              <p className="text-xs text-slate-500 mb-1">Copy from</p>
              <p className="font-semibold text-slate-900 text-sm">
                {formatDate(prevWeekStart)} – {formatDate(prevWeekEnd)}
              </p>
            </div>
            <ArrowRight className="text-slate-400 flex-shrink-0" size={20} />
            <div className="flex-1 bg-orange-50 border border-orange-200 rounded-lg p-3 text-center">
              <p className="text-xs text-orange-600 mb-1">Paste to (current week)</p>
              <p className="font-semibold text-slate-900 text-sm">
                {formatDate(weekDates[0])} – {formatDate(weekDates[6])}
              </p>
            </div>
          </div>

          {/* Info notice */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <p className="text-sm text-amber-800">
              Copied shifts will be created as <strong>drafts</strong>. Review them and publish when ready.
              Any existing shifts for this week will not be affected.
            </p>
          </div>

          <div className="flex gap-3 pt-1">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1"
              disabled={copying}
              data-testid="cancel-copy-last-week-btn"
            >
              Cancel
            </Button>
            <Button
              onClick={onCopy}
              className="flex-1"
              disabled={copying}
              data-testid="confirm-copy-last-week-btn"
            >
              {copying
                ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Copying...</>
                : <><Copy className="mr-2 h-4 w-4" />Copy Shifts</>
              }
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
